import React, { useState } from "react";
import styles from "./UpdateRoom.module.css";
import OnlyDropDown from "../../components/OnlyDropDown/OnlyDropDown";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice"; // adjust path as needed

const UpdateRoom = () => {
  const dispatch = useDispatch();

  const roomOptions = ["Room A", "Room B", "Room C", "Room D"];
  const [selectedRoom, setSelectedRoom] = useState("");

  const handleUpdate = () => {
    if (!selectedRoom) {
      alert("Please select a room");
      return;
    }

    console.log("Room updated to:", selectedRoom);
    // Optionally dispatch an updateRoom action
    dispatch(closeModal());
  };

  const handleCancel = () => {
    console.log("Update room cancelled");
    dispatch(closeModal());
  };

  return (
    <div className={styles.modalContainer}>
      <div className={styles.modalHeader}>Select Room</div>
      <div className={styles.modalBody}>
        <OnlyDropDown
          label="Choose Room"
          name="room"
          value={selectedRoom}
          options={roomOptions}
          onChange={(e) => setSelectedRoom(e.target.value)}
        />
      </div>
      <div className={styles.modalFooter}>
        <SaveAndCancel
          onCancel={handleCancel}
          onSave={handleUpdate}
          cancelLabel="Cancel"
          saveLabel="Update"
        />
      </div>
    </div>
  );
};

export default UpdateRoom;
